// extracted by mini-css-extract-plugin
export var closeButton = "_3a-3";
export var header = "_3a-0";
export var link = "_3a-1";
export var retryButton = "_3a-2";